// Google Analytics 4 (gtag.js) — graceful no-op when ID is empty.
let installedGaId = null;

export const loadGA = (measurementId) => {
    if (typeof window === "undefined") return;
    const id = (measurementId || "").trim();
    if (!id) return;
    if (installedGaId === id) return;
    if (installedGaId && installedGaId !== id) {
        // re-init for a new ID (admin changed it live)
        installedGaId = null;
    }

    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(id)}`;
    s.setAttribute("data-otp-ga", "true");
    document.head.appendChild(s);

    window.dataLayer = window.dataLayer || [];
    function gtag() { window.dataLayer.push(arguments); }
    window.gtag = gtag;
    gtag("js", new Date());
    gtag("config", id, { send_page_view: false });
    installedGaId = id;
};

// SPA page-view: send a standard GA4 page_view (for the "Pages and screens"
// report) plus a custom spa_page_view event, on every route change.
export const trackPageView = ({ path, title } = {}) => {
    if (typeof window === "undefined" || !window.gtag) return;
    const params = {
        page_path: path,
        page_location: window.location.origin + (path || window.location.pathname),
        page_title: title || document.title,
    };
    try {
        window.gtag("event", "page_view", params);
        window.gtag("event", "spa_page_view", { ...params });
    } catch (e) { console.debug("gtag page_view failed", e); }
};

export const trackEvent = (name, params = {}) => {
    if (typeof window === "undefined" || !window.gtag) return;
    try { window.gtag("event", name, params); } catch (e) { console.debug("gtag event failed", e); }
};
